import { DepthChartPlayer, Side } from "../../../types/DepthChartTypes";
import { RosterPlayer } from "../../../types/RosterTypes";

const getPosition = (rosterPlayer: RosterPlayer, selectedSide: Side): string => {
  let position = "";
  if (selectedSide === "OFFENSE") {
    position = rosterPlayer.player.offensive_position || "";
  } else if (selectedSide === "DEFENSE") {
    position = rosterPlayer.player.defensive_position || "";
  } else {
    position = `${rosterPlayer.player.offensive_position} / ${rosterPlayer.player.defensive_position}`;
  }
  return position;
}

// Transform roster players into a format for the player list
export const transformRosterPlayersToList = (rosterPlayers: RosterPlayer[], selectedSide: Side): DepthChartPlayer[] => {
  return rosterPlayers.map((rosterPlayer: RosterPlayer) => {
    return {
      id: rosterPlayer.player.id,
      name: rosterPlayer.player.name,
      roster_membership_id: rosterPlayer.id,
      jersey_number: rosterPlayer.jersey_number,
      status: rosterPlayer.status,
      position: getPosition(rosterPlayer, selectedSide),
      position_group: rosterPlayer.player.position_group,
      player: {
        id: rosterPlayer.player.id,
        name: rosterPlayer.player.name,
        offensive_position: rosterPlayer.player.offensive_position,
        defensive_position: rosterPlayer.player.defensive_position,
        position_group: rosterPlayer.player.position_group,
      }
    };
  });
};


// Check if player drop is in a valid position
export const isValidPositionDrop = (
  positionId: string, 
  playerId: number, 
  existingPlayers: DepthChartPlayer[]
): boolean => {
  // Check if player is already in the position
  if (!existingPlayers || existingPlayers.length === 0) {
    return true;
  }
  const playerExists = existingPlayers.some((p) => p && p.id === playerId);
  return !playerExists;
};

export const createDepthSlots = (players: DepthChartPlayer[], maxDepth: number) => {
  return Array(maxDepth)
    .fill(null)
    .map((_, index) => {
      return players[index] || null;
    });
};
